import Error from '../components/error';

export default function NoMatch() {
  return (
      <Error message='404'/>
  );
}
